module.exports = "../dist/frontend/icons/cards/green.svg?a1ef792425efccf9b03a87a6910d7773";